export class EnvFileParser {
  static parse(configuration: string): {[name: string]: string} {
    const lines = configuration.split(/\r?\n/);
    return lines.reduce((result, line) => {
      const splitLine = line.split('=');
      const name = splitLine.shift();
      const value = splitLine.join('=');
      if (name && value) {
        return {...result, [name]: value};
      } else {
        return result;
      }
    }, {});
  }
}
